import { issueMatchesWorkItemStatusCategory } from "./issueMappers";

export const EMPTY_EPIC_PROGRESS = { total: 0, done: 0, open: 0, percent: 0 };

export function isEpicChildWorkItemDone(row) {
  return issueMatchesWorkItemStatusCategory(row, "CLOSED");
}

export function normalizeEpicProgressPayload(epicProgress) {
  if (!epicProgress || typeof epicProgress !== "object") return null;
  const total = Math.max(0, Number(epicProgress.totalCount ?? epicProgress.total ?? 0) || 0);
  const done = Math.min(
    total,
    Math.max(0, Number(epicProgress.doneCount ?? epicProgress.done ?? 0) || 0)
  );
  const open = Math.max(
    0,
    Number(epicProgress.openCount ?? epicProgress.open ?? total - done) || total - done
  );
  const percent =
    epicProgress.percentComplete != null && Number.isFinite(Number(epicProgress.percentComplete))
      ? Math.round(Number(epicProgress.percentComplete))
      : total === 0
        ? 0
        : Math.round((done / total) * 100);
  return { total, done, open, percent };
}

/** Parse `epicProgress` from GET /work-items/:projectId?parentIds=… response root. */
export function parseEpicProgressFromWorkItemsResponse(raw) {
  const epicProgress = raw?.data?.epicProgress ?? raw?.epicProgress ?? null;
  return normalizeEpicProgressPayload(epicProgress);
}

export function resolveEpicProgressDisplay(mappedResponse, rowsFallback = []) {
  const fromApi = normalizeEpicProgressPayload(mappedResponse?.epicProgress);
  if (fromApi) return fromApi;
  return computeEpicChildProgress(rowsFallback);
}

export function computeEpicChildProgress(rows = []) {
  const list = Array.isArray(rows) ? rows : [];
  const total = list.length;
  const done = list.filter(isEpicChildWorkItemDone).length;
  return {
    total,
    done,
    open: total - done,
    percent: total === 0 ? 0 : Math.round((done / total) * 100),
  };
}

export function filterEpicChildRows(rows = [], { hideDone = true } = {}) {
  const list = Array.isArray(rows) ? rows : [];
  if (!hideDone) return list;
  return list.filter((row) => !isEpicChildWorkItemDone(row));
}
